<template>
  <div>
    <base-header
      class="header pb-0 pt-5 pt-lg-8 d-flex align-items-center bg-success"
      style="min-height: 50px; background-size: cover; background-position: center top;"
    >
      <!-- Mask -->
      <span class="bg-gradient-default opacity-8" />
      <!-- Header container -->
    </base-header>

    <div class="container-fluid mt-4">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-5">
                  <h3 class="mb-0">
                    Edit Business User
                  </h3>
                </div>
                <div class="col-7 text-left" />
              </div>
            </div>
            <template>
              <form @submit.prevent>
                <div class="">
                  <div class="row">
                    <div class="col-lg-12 mt-2">
                      <div
                        v-if="username"
                        class="error h5 text-danger pt-1 pl-1"
                      >
                        Username already exist
                      </div>
                      <div
                        v-if="usernamelength"
                        class="error h5 text-danger pt-1 pl-1"
                      >
                        Username length not less than 4
                      </div>
                      <div
                        v-if="specialcharacter"
                        class="error h5 text-danger pt-1 pl-1"
                      >
                        Only letters, numbers, periods (.) and underscores
                        (_) are allowed — no spaces
                      </div>
                      <base-input
                        alternative=""
                        label="Username"
                        placeholder="Username"
                        input-classes="form-control-alternative"
                        v-model="model.user_public_name"
                        @change="isValidusername()"
                      />
                      <small class="text-muted d-block mb-2">
                        The username is the page URL
                        (nabnee.com/business/username). Changing it changes
                        the URL. Always saved lowercase.
                      </small>
                    </div>
                    <div class="col-lg-12">
                      <div
                        v-if="!emailValid"
                        class="error h5 text-danger pt-1 pl-1"
                      >
                        Email is not valid
                      </div>
                      <base-input
                        alternative=""
                        label="Email"
                        placeholder="Email"
                        input-classes="form-control-alternative"
                        v-model="model.user_email"
                        @change="isValidEmail()"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Create Password"
                        placeholder="Change Password"
                        type="password"
                        input-classes="form-control-alternative"
                        v-model="model.user_password"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Business Name (English)"
                        placeholder="Business Name (English)"
                        input-classes="form-control-alternative"
                        v-model="model.business_name_english"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Business Description (English)"
                        placeholder="Business Description (English)"
                        input-classes="form-control-alternative"
                        v-model="model.business_description_english"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Business Name (Arabic)"
                        placeholder="Business Name (Arabic)"
                        input-classes="form-control-alternative"
                        v-model="model.business_name_arabic"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Business Description (Arabic)"
                        placeholder="Business Description (Arabic)"
                        input-classes="form-control-alternative"
                        v-model="model.business_description_arabic"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        type="file"
                        alternative=""
                        label="Logo"
                        placeholder="Logo"
                        @change="hadleimage"
                        input-classes="form-control-alternative"
                      />
                      <div v-if="uploadPercentage > 0 && uploadPercentage < 100" class="mt-2">
                        <label class="form-control-label">Upload Progress</label>
                        <base-progress :value="uploadPercentage" :show-percentage="true" />
                      </div>
                    </div>
                    <div
                      class="col-10 col-md-4 card-body offset-md-1 card shadow"
                      v-if="model.logo"
                    >
                      Logo:
                      <img :src="model.logo" class="img-fluid" />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        type="file"
                        alternative=""
                        label="Cover Image"
                        placeholder="Cover Image"
                        @change="hadleicon"
                        input-classes="form-control-alternative"
                      />
                      <div v-if="uploadPercentage > 0 && uploadPercentage < 100" class="mt-2">
                        <label class="form-control-label">Upload Progress</label>
                        <base-progress :value="uploadPercentage" :show-percentage="true" />
                      </div>
                    </div>
                    <div
                      class="col-10 col-md-4 card-body offset-md-1 card shadow"
                      v-if="model.cover_image"
                    >
                      Cover Image:
                      <img :src="model.cover_image" class="img-fluid" />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="No of quotes allowed"
                        placeholder="Business Description (English)"
                        input-classes="form-control-alternative"
                        v-model="model.noofquotes"
                      />
                    </div>

                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Max Hashtags"
                        placeholder="Number of allowed hashtags"
                        input-classes="form-control-alternative"
                        v-model="model.max_hashtags"
                      />
                    </div>

                    <div class="col-lg-12 mb-2">
                      <label class="form-control-label">Business Type</label>
                      <select
                        v-model="model.business_type"
                        class="form-control form-control-alternative"
                        autocomplete="off"
                      >
                        <option value="" disabled>Select type</option>
                        <option value="Designer">Designer</option>
                        <option value="Supplier">Supplier</option>
                        <option value="Designer + Supplier">Both</option>
                      </select>
                    </div>

                    <div class="col-md-12 mb-2">
                      <label class="form-control-label"
                        >Business Categories & Subcategories</label
                      >
                      <business-category-selector
                        :initial-selected-categories="model.business_categories"
                        :initial-selected-subcategories="
                          model.business_subcategories
                        "
                        @update:categories="model.business_categories = $event"
                        @update:subcategories="
                          model.business_subcategories = $event
                        "
                        :business-type="model.business_type"
                      />
                    </div>

                    <div class="col-lg-12 mb-2">
                      <label class="form-control-label"
                        >Business GPS Address (Google Map API)</label
                      >
                      <vue-google-autocomplete
                        ref="address"
                        id="map"
                        classname="form-control mb-0"
                        placeholder="Business GPS Address"
                        v-on:placechanged="getAddressData"
                        types="establishment"
                      >
                      </vue-google-autocomplete>
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Business GPS Address (Link)"
                        placeholder="Business GPS Address"
                        input-classes="form-control-alternative"
                        v-model="model.gpslink"
                      />
                    </div>
                    <div class="col-md-12 mb-2">
                      <label class="form-control-label">Country</label>
                      <select
                        aria-describedby="addon-right addon-left"
                        v-model="model.user_country"
                        class="form-control form-control-alternative"
                        autocomplete="off"
                      >
                        <option value="">Select country</option>
                        <option
                          v-for="country in countrydata"
                          :key="country._id"
                          :value="country.country_name"
                          >{{ country.country_name }}</option
                        >
                      </select>
                    </div>
                    <div class="col-12 mb-2">
                      <label class="form-control-label">City</label>
                      <select
                        aria-describedby="addon-right addon-left"
                        class="form-control form-control-alternative"
                        autocomplete="off"
                        @change="filtercitybusiness()"
                        v-model="model.business_city"
                      >
                        <option value="" disabled="">Select city</option>
                        <option
                          v-for="city in cities"
                          :value="city.filter_name"
                          :key="city.filter_name"
                        >
                          {{
                            city.filter_name + ' (' + city.filter_name_ar + ')'
                          }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Business Address (English)"
                        placeholder="Business Address (English)"
                        input-classes="form-control-alternative"
                        v-model="model.address"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Business Address (Arabic)"
                        placeholder="Business Address (Arabic)"
                        input-classes="form-control-alternative"
                        v-model="model.address_ar"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Phone"
                        placeholder="Phone"
                        input-classes="form-control-alternative"
                        v-model="model.user_phone"
                      />
                    </div>
                    <!-- business hours -->
                    <div class="col-lg-12">
                      <hr />
                    </div>
                    <!-- business hours -->
                    <div class="col-lg-12">
                      <div class="row mb-4 w-100">
                        <div class="col-12">
                          <div class="d-flex align-items-center mb-3">
                            <div>
                              <h4 class="mb-0 font-weight-800 text-dark">
                                Business Hours
                              </h4>
                              <p class="text-muted mb-0">
                                Set your business operating hours for customers
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div
                        class="card shadow border-0 mb-5"
                        style="border-radius: 12px;"
                      >
                        <div class="card-header bg-white border-0 py-4">
                          <div
                            class="d-flex justify-content-between align-items-center"
                          >
                            <div>
                              <h5 class="mb-1 font-weight-bold text-dark">
                                Set Operating Hours
                              </h5>
                              <p class="mb-0 text-muted small">
                                Configure when your business is open
                              </p>
                            </div>
                            <div class="d-flex align-items-center">
                              <span class="text-muted small mr-3"
                                >Apply to all days</span
                              >
                              <div class="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  id="sameas"
                                  v-model="checkvalue"
                                  @click="sameastime()"
                                />
                                <label
                                  class="custom-control-label"
                                  for="sameas"
                                ></label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card-body p-4">
                          <div class="hours-container">
                            <div
                              class="hour-row"
                              v-for="(day, index) in business_hours"
                              :key="index"
                            >
                              <div
                                class="d-flex align-items-center justify-content-between py-3 px-3 rounded-lg mb-2 google-hour-row"
                                :class="{ 'closed-day-row': day.closed }"
                              >
                                <div class="day-name">
                                  <span
                                    class="font-weight-600"
                                    :class="
                                      day.closed ? 'text-muted' : 'text-dark'
                                    "
                                  >
                                    {{
                                      [
                                        'Sunday',
                                        'Monday',
                                        'Tuesday',
                                        'Wednesday',
                                        'Thursday',
                                        'Friday',
                                        'Saturday',
                                      ][index]
                                    }}
                                  </span>
                                </div>

                                <div
                                  class="time-controls d-flex align-items-center"
                                  v-if="!day.closed"
                                >
                                  <div class="time-input-group mr-3">
                                    <vue-timepicker
                                      v-model="day.from"
                                      format="hh:mm A"
                                      placeholder="8:00 AM"
                                      @change="
                                        checktime(day.from, day.to, 'add')
                                      "
                                      class="google-time-picker"
                                      :input-class="
                                        'form-control text-center google-time-input'
                                      "
                                    ></vue-timepicker>
                                  </div>
                                  <span class="text-muted mx-2 font-weight-500"
                                    >–</span
                                  >
                                  <div class="time-input-group mr-3">
                                    <vue-timepicker
                                      v-model="day.to"
                                      format="hh:mm A"
                                      placeholder="11:00 PM"
                                      @change="
                                        sameastime();
                                        checktime(day.from, day.to, 'add');
                                      "
                                      class="google-time-picker"
                                      :input-class="
                                        'form-control text-center google-time-input'
                                      "
                                    ></vue-timepicker>
                                  </div>
                                </div>

                                <div
                                  class="closed-status d-flex align-items-center"
                                  v-if="day.closed"
                                >
                                  <span
                                    class="text-danger font-weight-600 closed-text"
                                  >
                                    <i class="fas fa-times-circle mr-2"></i
                                    >Closed
                                  </span>
                                </div>

                                <div class="closed-toggle">
                                  <div class="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      class="custom-control-input"
                                      :id="'closed-business-' + index"
                                      v-model="day.closed"
                                      @change="toggleBusinessDay(index)"
                                    />
                                    <label
                                      class="custom-control-label text-muted small cursor-pointer"
                                      :for="'closed-business-' + index"
                                    >
                                      Closed
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Error Alert -->
                          <div
                            id="timev"
                            class="alert alert-danger border-0 mt-3"
                            style="display: none; border-radius: 8px;"
                          >
                            <div class="d-flex align-items-center">
                              <i
                                class="fas fa-exclamation-triangle text-danger mr-2"
                              ></i>
                              <span class="small"
                                >Please check your opening and closing
                                times.</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 d-flex mt-2">
                      <div class="row mb-4 w-100">
                        <div class="col-12">
                          <div class="d-flex align-items-center mb-3">
                            <div>
                              <h4 class="mb-0 font-weight-800 text-dark">
                                Leisure & Break Hours
                              </h4>
                              <p class="text-muted mb-0">
                                Set up break times and leisure hours for your
                                business
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div
                        class="card shadow border-0 mb-5"
                        style="border-radius: 12px;"
                      >
                        <div class="card-header bg-white border-0 py-4">
                          <div
                            class="d-flex justify-content-between align-items-center"
                          >
                            <div>
                              <h5 class="mb-1 font-weight-bold text-dark">
                                Break Hours
                              </h5>
                              <p class="mb-0 text-muted small">
                                Set your business break times
                              </p>
                            </div>
                            <div class="d-flex align-items-center">
                              <span class="text-muted small mr-3"
                                >Apply to all days</span
                              >
                              <div class="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  id="lsameas"
                                  v-model="lcheckvalue"
                                  @click="lsameastime()"
                                />
                                <label
                                  class="custom-control-label"
                                  for="lsameas"
                                ></label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card-body p-4">
                          <div class="hours-container">
                            <div
                              class="hour-row"
                              v-for="(day, index) in leisure_hours"
                              :key="index"
                            >
                              <div
                                class="d-flex align-items-center justify-content-between py-3 px-3 rounded-lg mb-2 google-hour-row"
                                :class="{ 'closed-day-row': day.closed }"
                              >
                                <div class="day-name">
                                  <span
                                    class="font-weight-600"
                                    :class="
                                      day.closed ? 'text-muted' : 'text-dark'
                                    "
                                  >
                                    {{
                                      [
                                        'Sunday',
                                        'Monday',
                                        'Tuesday',
                                        'Wednesday',
                                        'Thursday',
                                        'Friday',
                                        'Saturday',
                                      ][index]
                                    }}
                                  </span>
                                </div>

                                <div
                                  class="time-controls d-flex align-items-center"
                                  v-if="!day.closed"
                                >
                                  <div class="time-input-group mr-3">
                                    <vue-timepicker
                                      v-model="day.from"
                                      format="hh:mm A"
                                      placeholder="1:00 PM"
                                      @change="
                                        lchecktime(day.from, day.to, 'add')
                                      "
                                      class="google-time-picker"
                                      :input-class="
                                        'form-control text-center google-time-input'
                                      "
                                    ></vue-timepicker>
                                  </div>
                                  <span class="text-muted mx-2 font-weight-500"
                                    >–</span
                                  >
                                  <div class="time-input-group mr-3">
                                    <vue-timepicker
                                      v-model="day.to"
                                      format="hh:mm A"
                                      placeholder="2:00 PM"
                                      @change="
                                        lsameastime();
                                        lchecktime(day.from, day.to, 'add');
                                      "
                                      class="google-time-picker"
                                      :input-class="
                                        'form-control text-center google-time-input'
                                      "
                                    ></vue-timepicker>
                                  </div>
                                </div>

                                <div
                                  class="closed-status d-flex align-items-center"
                                  v-if="day.closed"
                                >
                                  <span
                                    class="text-muted font-weight-600 closed-text"
                                  >
                                    <i class="fas fa-coffee mr-2"></i>No break
                                  </span>
                                </div>

                                <div class="closed-toggle">
                                  <div class="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      class="custom-control-input"
                                      :id="'closed-leisure-' + index"
                                      v-model="day.closed"
                                      @change="toggleLeisureDay(index)"
                                    />
                                    <label
                                      class="custom-control-label text-muted small cursor-pointer"
                                      :for="'closed-leisure-' + index"
                                    >
                                      No break
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Error Alert -->
                          <div
                            id="ltimev"
                            class="alert alert-danger border-0 mt-3"
                            style="display: none; border-radius: 8px;"
                          >
                            <div class="d-flex align-items-center">
                              <i
                                class="fas fa-exclamation-triangle text-danger mr-2"
                              ></i>
                              <span class="small"
                                >Please check your break start and end
                                times.</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <hr />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Website"
                        placeholder="Website"
                        input-classes="form-control-alternative"
                        v-model="model.web_link"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Facebook Link"
                        placeholder="username only"
                        input-classes="form-control-alternative"
                        v-model="model.fb_link"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="Instagram Link"
                        placeholder="username only"
                        input-classes="form-control-alternative"
                        v-model="model.instagram_link"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="YouTube Link"
                        placeholder="channel_id"
                        input-classes="form-control-alternative"
                        v-model="model.youtube_link"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="X (Twitter) Link"
                        placeholder="twitter handle only"
                        input-classes="form-control-alternative"
                        v-model="model.twitter_link"
                      />
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        label="WhatsApp Number"
                        placeholder="e.g. +968 9999 9999"
                        input-classes="form-control-alternative"
                        v-model="model.whatsapp_number"
                      />
                    </div>

                    <div class="col-lg-12 mb-3">
                      <div
                        class="custom-control custom-checkbox fancy-claim-checkbox"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="sendClaimEmail"
                          v-model="sendClaimEmail"
                          @change="onSendClaimEmailChange"
                          :disabled="sendingClaimEmail"
                        />
                        <label
                          class="custom-control-label"
                          for="sendClaimEmail"
                        >
                          <span
                            v-if="sendingClaimEmail"
                            class="spinner-border spinner-border-sm mr-2"
                            role="status"
                          ></span>
                          <span
                            v-else-if="claimEmailSent"
                            class="text-success mr-2"
                            ><i class="fas fa-check-circle"></i
                          ></span>
                          Send Claim Email
                        </label>
                      </div>
                      <div
                        v-if="claimEmailError"
                        class="text-danger mt-1 small"
                      >
                        {{ claimEmailError }}
                      </div>
                      <div
                        v-if="claimEmailSent"
                        class="text-success mt-1 small"
                      >
                        Claim email sent!
                      </div>
                    </div>

                    <div class="col-lg-12 mb-3">
                      <base-button
                        type="secondary"
                        size="sm"
                        :disabled="generatingClaimLink"
                        @click="generateClaimLink"
                      >
                        <span
                          v-if="generatingClaimLink"
                          class="spinner-border spinner-border-sm mr-2"
                          role="status"
                        ></span>
                        <i v-else class="fas fa-link mr-1"></i>
                        Generate Claim Link
                      </base-button>
                      <div v-if="claimLink" class="input-group mt-2">
                        <input
                          type="text"
                          class="form-control"
                          :value="claimLink"
                          readonly
                          ref="claimLinkInput"
                          @focus="$event.target.select()"
                        />
                        <div class="input-group-append">
                          <button
                            class="btn btn-outline-primary"
                            type="button"
                            @click="copyClaimLink"
                          >
                            <i class="fas fa-copy mr-1"></i
                            >{{ claimLinkCopied ? 'Copied!' : 'Copy' }}
                          </button>
                        </div>
                      </div>
                      <div v-if="claimLink" class="text-muted mt-1 small">
                        Link is valid for 7 days. Copy it and send it to the
                        business directly (e.g. via WhatsApp).
                      </div>
                      <div
                        v-if="claimLinkError"
                        class="text-danger mt-1 small"
                      >
                        {{ claimLinkError }}
                      </div>
                    </div>

                    <div class="col-lg-12">
                      <base-button
                        :disabled="
                          usernamelength ||
                            username ||
                            specialcharacter ||
                            !emailValid
                        "
                        type="primary"
                        id="saveuserbtn"
                        @click="updatebusiness()"
                        >Update Business</base-button
                      >
                    </div>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import VueSwal from 'vue-swal';
import moment from 'moment';
import VueTimepicker from 'vue2-timepicker';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import 'vue2-timepicker/dist/VueTimepicker.css';
import BusinessCategorySelector from '@/components/BusinessCategorySelector.vue';
import { compressImageIfNeeded } from '../utils/imageCompression';
const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function normalizeDayAbbr(day) {
  if (!day) return '';
  const d = String(day).trim();
  const mapFullToAbbr = {
    Sunday: 'Sun',
    Monday: 'Mon',
    Tuesday: 'Tue',
    Wednesday: 'Wed',
    Thursday: 'Thu',
    Friday: 'Fri',
    Saturday: 'Sat',
  };
  if (mapFullToAbbr[d]) return mapFullToAbbr[d];
  // Already abbreviated or different casing
  const upper = d.slice(0, 1).toUpperCase() + d.slice(1, 3).toLowerCase();
  if (DAYS.includes(upper)) return upper;
  return d;
}

function getHourForDay(hoursArr, day) {
  return hoursArr.find((h) => h.day === day);
}

export default {
  name: 'AddQuestion',
  components: {
    VueTimepicker,
    VueGoogleAutocomplete,
    BusinessCategorySelector,
    VueTimepicker,
    VueGoogleAutocomplete,
  },
  props: ['id'],
  data() {
    return {
      sendClaimEmail: false,
      sendingClaimEmail: false,
      claimEmailSent: false,
      claimEmailError: '',

      generatingClaimLink: false,
      claimLink: '',
      claimLinkError: '',
      claimLinkCopied: false,

      selected: false,
      checkvalue: false,
      emailValid: true,
      username: false,
      usernamelength: false,
      specialcharacter: false,
      originalUsername: '',
      lcheckvalue: false,
      gpslink: '',
      address: '',
      searchData: [],
      categories: [],
      subcategories: [],
      cities: [],

      countrydata: [],
      // businessData:[],
      uploadPercentage: 0,
      business_hours: [
        {
          day: 'Sun',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Mon',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Tue',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Wed',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Thu',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Fri',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Sat',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
      ],
      leisure_hours: [
        {
          day: 'Sun',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Mon',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Tue',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Wed',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Thu',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Fri',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
        {
          day: 'Sat',
          from: { hh: '', mm: '', A: 'AM' },
          to: { hh: '', mm: '', A: 'AM' },
          closed: false,
        },
      ],

      model: {
        user_id: '',
        user_type: '',
        user_public_name: '',
        user_public_name: '',
        user_email: '',
        user_fcm: '',
        user_gid: '',
        user_fid: '',
        user_dp: '',
        user_password: '',
        user_permissions: '',
        user_phone: '',
        user_language: '',
        user_country: '',
        user_status: '',
        business_name_english: '',
        business_name_arabic: '',
        business_category: [],
        business_subcategory: [],
        business_email: '',
        business_type: '',
        business_brand: '',
        business_brand_ar: '',
        business_space: '',
        business_space_ar: '',
        business_city: '',
        business_city_ar: '',
        business_hours: '',
        leisure_hours: '',
        location_lat: '',
        location_long: '',
        address: '',
        address_ar: '',
        logo: '',
        noofquotes: '',
        max_hashtags: '',
        cover_image: '',
        business_description_english: '',
        business_description_arabic: '',
        web_link: '',
        fb_link: '',
        instagram_link: '',
        youtube_link: '',
        twitter_link: '',
        whatsapp_number: '',
        ratings: '',
        business_featured: '',
        user_likes: '',
        business_user_since: '',
        gpslink: '',
      },
      message: '',
      auth: {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'nabnee#' + localStorage.getItem('accessToken'),
          _id: localStorage.getItem('_id'),
        },
      },
      auth1: {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: 'nabnee#' + localStorage.getItem('accessToken'),
          _id: localStorage.getItem('_id'),
        },
      },
      path: '',
      statuses: {
        1: { id: 'pending', val: 'pending' },
        2: { id: 'approved', val: 'approved' },
      },
    };
  },
  mounted() {
    this.path = process.env.VUE_APP_API_ENDPOINT;

    const querystring = require('querystring');
    // console.log(this.auth);
    // axios
    // .post(process.env.VUE_APP_API_ENDPOINT+'read_business_all',{"details" :{ "user_type":"Business"},"offset" :"0"})
    // .then(response => {
    //   // console.log(response);
    //   if(response.data.details){
    //   this.businessData=response.data.details;
    //   }

    // })

    axios
      .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_category', {
        status: 'approved',
      })
      .then((response) => {
        console.log('Current business', response);
        if (response.data.details) {
          this.categories = response.data.details;
        }
      });

    axios
      .post(process.env.VUE_APP_API_ENDPOINT + 'read_business_filter_all')
      .then((response) => {
        console.log(response);
        if (response.data.details) {
          this.cities = response.data.details;
        }
      });

    axios
      .post(
        process.env.VUE_APP_API_ENDPOINT + 'read_business_by_id',
        { user_id: this.$route.params.id },
        this.auth
      )
      .then((response) => {
        if (response.data.details) {
          const mainData = response.data.details[0];
          console.log('main data fetched', mainData);

          // Normalize categories
          this.model.business_categories = Array.isArray(
            mainData.business_category
          )
            ? mainData.business_category.map((cat) => cat._id)
            : [];
          // Normalize subcategories
          this.model.business_subcategories = Array.isArray(
            mainData.business_subcategory
          )
            ? mainData.business_subcategory.map((sub) => sub._id)
            : [];

          // Find main branch if exists
          let mainBranch = null;
          if (Array.isArray(mainData.branches)) {
            mainBranch = mainData.branches.find((b) => b.is_main);
          }
          // Assign all fields as before
          Object.keys(mainData).forEach((key) => {
            if (key in this.model) {
              this.model[key] = mainData[key];
            }
          });

          this.model._id = mainData._id;
          // --- Add normalization here ---
          if (Array.isArray(this.model.business_category)) {
            this.model.business_category =
              this.model.business_category.length > 0 &&
              this.model.business_category[0]._id
                ? this.model.business_category[0]._id
                : '';
          } else if (
            typeof this.model.business_category === 'object' &&
            this.model.business_category !== null
          ) {
            this.model.business_category =
              this.model.business_category._id || '';
          }

          if (Array.isArray(this.model.business_subcategory)) {
            this.model.business_subcategory =
              this.model.business_subcategory.length > 0 &&
              this.model.business_subcategory[0]._id
                ? this.model.business_subcategory[0]._id
                : '';
          } else if (
            typeof this.model.business_subcategory === 'object' &&
            this.model.business_subcategory !== null
          ) {
            this.model.business_subcategory =
              this.model.business_subcategory._id || '';
          }

          // Fallback for business_name_english and business_name_arabic
          if (
            (!this.model.business_name_english ||
              this.model.business_name_english === '') &&
            mainBranch &&
            mainBranch.name
          ) {
            this.model.business_name_english = mainBranch.name;
          }
          if (
            (!this.model.business_name_arabic ||
              this.model.business_name_arabic === '') &&
            mainBranch &&
            mainBranch.name_ar
          ) {
            this.model.business_name_arabic = mainBranch.name_ar;
          }
          // Fallback for address_ar
          if (
            (!this.model.address_ar || this.model.address_ar === '') &&
            mainBranch &&
            mainBranch.address_ar
          ) {
            this.model.address_ar = mainBranch.address_ar;
          }
          // Fallback for address
          if (
            (!this.model.address || this.model.address === '') &&
            mainBranch &&
            mainBranch.address
          ) {
            this.model.address = mainBranch.address;
          }

          // Prefill GPS link if lat/long exist and gpslink is empty
          if (
            mainData.location_lat &&
            mainData.location_long &&
            (!this.model.gpslink || this.model.gpslink === '')
          ) {
            this.model.gpslink = `https://www.google.com/maps?q=${
              mainData.location_lat
            },${mainData.location_long}`;
          }

          Object.keys(response.data.details[0]).forEach((key) => {
            if (key in this.model) {
              this.model[key] = response.data.details[0][key];
            }
          });
          this.originalUsername =
            response.data.details[0].user_public_name || '';
          this.$set(
            this.model,
            'address_ar',
            response.data.details[0].address_ar || ''
          );
          console.log('Arabic address loaded:', this.model.address_ar);
          // Normalize category
          if (Array.isArray(this.model.business_category)) {
            this.model.business_category =
              this.model.business_category.length > 0 &&
              this.model.business_category[0]._id
                ? this.model.business_category[0]._id
                : '';
          } else if (typeof this.model.business_category === 'object') {
            this.model.business_category =
              this.model.business_category._id || '';
          }

          // Load subcategories for the selected category
          if (this.model.business_category) {
            this.getbusinesssubcategories();
          }

          // Normalize subcategory (wait for subcategories to load)
          this.$nextTick(() => {
            if (Array.isArray(this.model.business_subcategory)) {
              this.model.business_subcategory =
                (this.model.business_subcategory[0] &&
                  this.model.business_subcategory[0]._id) ||
                '';
            } else if (typeof this.model.business_subcategory === 'object') {
              this.model.business_subcategory =
                this.model.business_subcategory._id || '';
            }
          });

          if (this.model.user_country) {
            //this.model.user_country=localStorage.getItem('country_name');
          }

          if (this.model.business_category) {
            this.model.business_category = this.model.business_category._id;
            axios
              .post(
                process.env.VUE_APP_API_ENDPOINT + 'read_business_subcategory',
                querystring.stringify({
                  business_category_oid: this.model.business_category,
                }),
                this.auth1
              )
              .then((response) => {
                // console.log(response);
                if (response.data.details) {
                  this.subcategories = response.data.details;
                  //this.model.category_name=response.data.subcategory_data[0].category_name;
                }
              });
          }
          if (this.model.business_subcategory) {
            this.model.business_subcategory = this.model.business_subcategory._id;
          }

          if (this.model.business_hours) {
            console.log('intial parsed input', this.model.business_hours);
            let parsedHours = Array.isArray(this.model.business_hours)
              ? this.model.business_hours
              : JSON.parse(this.model.business_hours);
            console.log('parsed hours', parsedHours);

            // Normalize incoming day keys then map Sunday-first
            const normalized = parsedHours.map((h) => ({
              ...h,
              day: normalizeDayAbbr(h.day),
            }));
            this.business_hours = DAYS.map((day) => {
              const hour = normalized.find((h) => h.day === day);
              console.log('hours for day', day, hour);
              if (hour) {
                return {
                  day,
                  from: hour.from
                    ? typeof hour.from === 'string'
                      ? this.convertTimeStringToObject(hour.from)
                      : hour.from
                    : { hh: '', mm: '', A: 'AM' },
                  to: hour.to
                    ? typeof hour.to === 'string'
                      ? this.convertTimeStringToObject(hour.to)
                      : hour.to
                    : { hh: '', mm: '', A: 'AM' },
                  closed: false,
                };
              } else {
                // No data for this day, mark as closed
                return {
                  day,
                  from: { hh: '', mm: '', A: 'AM' },
                  to: { hh: '', mm: '', A: 'AM' },
                  closed: true,
                };
              }
            });
          }

          if (this.model.leisure_hours) {
            let parsedHours = Array.isArray(this.model.leisure_hours)
              ? this.model.leisure_hours
              : JSON.parse(this.model.leisure_hours);

            const normalizedLeisure = parsedHours.map((h) => ({
              ...h,
              day: normalizeDayAbbr(h.day),
            }));
            this.leisure_hours = DAYS.map((day) => {
              const hour = normalizedLeisure.find((h) => h.day === day);
              console.log('leisure hours for day', day, hour);
              if (hour) {
                return {
                  day,
                  from: hour.from
                    ? typeof hour.from === 'string'
                      ? this.convertTimeStringToObject(hour.from)
                      : hour.from
                    : { hh: '', mm: '', A: 'AM' },
                  to: hour.to
                    ? typeof hour.to === 'string'
                      ? this.convertTimeStringToObject(hour.to)
                      : hour.to
                    : { hh: '', mm: '', A: 'AM' },
                  closed: false,
                };
              } else {
                // No data for this day, mark as closed
                return {
                  day,
                  from: { hh: '', mm: '', A: 'AM' },
                  to: { hh: '', mm: '', A: 'AM' },
                  closed: true,
                };
              }
            });
          }
        }
      });

    axios
      .post(process.env.VUE_APP_API_ENDPOINT + 'read_country', {
        details: { status: 'approved' },
        offset: '0',
      })
      .then((response) => {
        // console.log(response);
        if (response.data.details) {
          this.countrydata = response.data.details;
        }
      });
  },
  methods: {
    async onSendClaimEmailChange() {
      if (this.sendClaimEmail) {
        this.sendingClaimEmail = true;
        this.claimEmailSent = false;
        this.claimEmailError = '';
        try {
          await this.sendClaimEmailApi();
          this.claimEmailSent = true;
        } catch (e) {
          console.log('errr', e);
          this.claimEmailError = 'Failed to send claim email.';
          this.sendClaimEmail = false;
        }
        this.sendingClaimEmail = false;
      } else {
        this.claimEmailSent = false;
        this.claimEmailError = '';
      }
    },
    async sendClaimEmailApi() {
      console.log('📤 Sending Claim Email payload:', {
        user_email: this.model.user_email,
        business_name: this.model.business_name_english,
        user_name: this.model.user_public_name,
        language: this.model.user_language,
      });

      try {
        const response = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + 'send_business_claim_email',
          {
            user_email: this.model.user_email,
            business_name: this.model.business_name_english,
            user_name: this.model.user_public_name,
            language: this.model.user_language,
          },
          this.auth
        );

        console.log('✅ send_business_claim_email response:', response);
        return response;
      } catch (err) {
        console.error(
          '❌ send_business_claim_email error:',
          err.response || err
        );
        throw err;
      }
    },

    async generateClaimLink() {
      this.generatingClaimLink = true;
      this.claimLink = '';
      this.claimLinkError = '';
      this.claimLinkCopied = false;
      try {
        const response = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + 'generate_business_claim_link',
          { user_email: this.model.user_email },
          this.auth
        );
        if (response.data && response.data.success) {
          this.claimLink = response.data.claim_link;
        } else {
          this.claimLinkError =
            (response.data && response.data.message) ||
            'Failed to generate claim link.';
        }
      } catch (err) {
        console.error(
          '❌ generate_business_claim_link error:',
          err.response || err
        );
        this.claimLinkError = 'Failed to generate claim link.';
      }
      this.generatingClaimLink = false;
    },

    copyClaimLink() {
      const markCopied = () => {
        this.claimLinkCopied = true;
        setTimeout(() => {
          this.claimLinkCopied = false;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.claimLink).then(markCopied);
      } else {
        // Fallback for non-secure (http) admin origins where the
        // Clipboard API is unavailable.
        const input = this.$refs.claimLinkInput;
        input.select();
        document.execCommand('copy');
        markCopied();
      }
    },

    getCategoryName(catId) {
      const cat = this.categories.find((c) => c._id === catId);
      return cat ? cat.business_category_name : catId;
    },
    getSubcategoryName(subId) {
      const sub = this.subcategories.find((s) => s._id === subId);
      return sub ? sub.business_subcategory_name : subId;
    },

    addCategory(event) {
      if (!this.model.business_category) this.model.business_category = [];
      if (!this.model.business_category.includes(this.selectedCategory)) {
        this.model.business_category.push(this.selectedCategory);
      }
      this.selectedCategory = ''; // reset select
    },
    removeCategory(catId) {
      this.model.business_category = this.model.business_category.filter(
        (id) => id !== catId
      );
    },
    removeSubcategory(subId) {
      const idx = this.model.business_subcategories.indexOf(subId);
      if (idx !== -1) {
        this.model.business_subcategories.splice(idx, 1);
      }
    },
    getAddressData: function(addressData, placeResultData, id) {
      this.address = addressData;
      let place = document.getElementById('map').value;
      // console.log(this.address);
      this.model.address = place;
      this.model.user_country = this.address.country;
    },
    hadleimage: async function(event) {
      // Reference to the DOM input element
      this.uploadPercentage = 0;
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB limit
      if (input.files[0].size < MAX_FILE_SIZE) {
        // Compress image if it's larger than 2MB
        const compressedFile = await compressImageIfNeeded(input.files[0]);
        
        const fd = new FormData();
        fd.append('image', compressedFile, compressedFile.name);
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + 'image-upload', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: function(progressEvent) {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
              console.log(this.uploadPercentage);
            }.bind(this),
          })
          .then((response) => {
            //// console.log(response);
            this.model.logo = response.data.imageUrl;
          });
      } else {
        swal({
          title: 'File too large!',
          text:
            'Your file is larger than 50 MB. Please upload images which are less than 50 MB.',
          icon: 'warning',
        }).then((result) => {});
      }
    },

    hadleicon: async function(event) {
      // Reference to the DOM input element
      this.uploadPercentage = 0;
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB limit
      if (input.files[0].size < MAX_FILE_SIZE) {
        // Compress image if it's larger than 2MB
        const compressedFile = await compressImageIfNeeded(input.files[0]);
        
        const fd = new FormData();
        fd.append('image', compressedFile, compressedFile.name);
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + 'image-upload', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: function(progressEvent) {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
              console.log(this.uploadPercentage);
            }.bind(this),
          })
          .then((response) => {
            //// console.log(response);
            this.model.cover_image = response.data.imageUrl;
          });
      } else {
        swal({
          title: 'File to large!',
          text:
            'Your file is larger than 5 MB. Please upload images which are less than 5 MB.',
          icon: 'warning',
        }).then((result) => {});
      }
    },
    checktime(start_time, end_time, type) {
      // // console.log(start_time);
      let start_time1 =
        start_time.hh + ':' + start_time.mm + ' ' + start_time.A;
      let end_time1 = end_time.hh + ':' + end_time.mm + ' ' + end_time.A;
      var startTime = moment(start_time1, 'HH:mm a');
      var endTime = moment(end_time1, 'HH:mm a');
      if (endTime.hour() < startTime.hour()) {
        // console.log("Batch start time can't be greater than batch end time");
        if (type == 'edit') {
          document.getElementById('edittimev').innerHTML =
            "Batch start time can't be greater than batch end time";
        } else {
          document.getElementById('timev').innerHTML =
            "Batch start time can't be greater than batch end time";
        }
      } else if (
        endTime.hour() == startTime.hour() &&
        endTime.minute() <= startTime.minute()
      ) {
        if (type == 'edit') {
          document.getElementById('edittimev').innerHTML =
            "Batch start time can't be equal or greater than batch end time";
        } else {
          document.getElementById('timev').innerHTML =
            "Batch start time can't be equal or greater than batch end time";
        }
      } else {
        if (type == 'edit') {
          document.getElementById('edittimev').innerHTML = '';
        } else {
          document.getElementById('timev').innerHTML = '';
        }
      }
      return false;
    },
    sameastime() {
      const inputElements = document.getElementById('sameas');
      if (!inputElements || !inputElements.checked) return;

      // Find first day with valid times to copy from
      const src = this.business_hours.find(
        (d) => d && d.from && d.from.hh && d.to && d.to.hh
      );
      if (!src) return;
      const start_time = JSON.parse(JSON.stringify(src.from));
      const end_time = JSON.parse(JSON.stringify(src.to));

      for (let i = 0; i < this.business_hours.length; i++) {
        if (this.business_hours[i].closed) continue;
        this.business_hours[i].from = JSON.parse(JSON.stringify(start_time));
        this.business_hours[i].to = JSON.parse(JSON.stringify(end_time));
      }
    },
    selectday(value) {
      const index = this.days.map((e) => e.day).indexOf(value);
      // // console.log(index);
      if (index == -1) {
        document.getElementById(value).classList.add('active');
        this.days.push({
          day: value,
          start_time: { hh: '', mm: '', A: '' },
          end_time: { hh: '', mm: '', A: '' },
        });
        // // console.log(this.days);
      } else {
        this.days.splice(index, 1);
        document.getElementById(value).classList.remove('active');
        // // console.log(this.days);
      }
    },
    removeday(index) {
      document.getElementById(this.days[index].day).classList.remove('active');
      this.days.splice(index, 1);
      // // console.log(this.days);
    },
    lchecktime(start_time, end_time, type) {
      // // console.log(start_time);
      let start_time1 =
        start_time.hh + ':' + start_time.mm + ' ' + start_time.A;
      let end_time1 = end_time.hh + ':' + end_time.mm + ' ' + end_time.A;
      var startTime = moment(start_time1, 'HH:mm a');
      var endTime = moment(end_time1, 'HH:mm a');
      if (endTime.hour() < startTime.hour()) {
        // console.log("Batch start time can't be greater than batch end time");
        if (type == 'edit') {
          document.getElementById('ledittimev').innerHTML =
            "Batch start time can't be greater than batch end time";
        } else {
          document.getElementById('ltimev').innerHTML =
            "Batch start time can't be greater than batch end time";
        }
      } else if (
        endTime.hour() == startTime.hour() &&
        endTime.minute() <= startTime.minute()
      ) {
        // console.log("Batch start time can't be equal or greater than batch end time");
        if (type == 'edit') {
          document.getElementById('ledittimev').innerHTML =
            "Batch start time can't be equal or greater than batch end time";
        } else {
          document.getElementById('ltimev').innerHTML =
            "Batch start time can't be equal or greater than batch end time";
        }
      } else {
        if (type == 'edit') {
          document.getElementById('ledittimev').innerHTML = '';
        } else {
          document.getElementById('ltimev').innerHTML = '';
        }
      }
      return false;
    },
    lsameastime() {
      const inputElements = document.getElementById('lsameas');
      if (!inputElements || !inputElements.checked) return;

      // Find first day with valid times to copy from
      const src = this.leisure_hours.find(
        (d) => d && d.from && d.from.hh && d.to && d.to.hh
      );
      if (!src) return;
      const start_time = JSON.parse(JSON.stringify(src.from));
      const end_time = JSON.parse(JSON.stringify(src.to));

      for (let i = 0; i < this.leisure_hours.length; i++) {
        if (this.leisure_hours[i].closed) continue;
        this.leisure_hours[i].from = JSON.parse(JSON.stringify(start_time));
        this.leisure_hours[i].to = JSON.parse(JSON.stringify(end_time));
      }
    },
    lselectday(value) {
      const index = this.ldays.map((e) => e.day).indexOf(value);
      // // console.log(index);
      if (index == -1) {
        document.getElementById(value).classList.add('active');
        this.ldays.push({
          day: value,
          start_time: { hh: '', mm: '', A: '' },
          end_time: { hh: '', mm: '', A: '' },
        });
        // // console.log(this.days);
      } else {
        this.ldays.splice(index, 1);
        document.getElementById(value).classList.remove('active');
        // // console.log(this.days);
      }
    },
    lremoveday(index) {
      document.getElementById(this.ldays[index].day).classList.remove('active');
      this.ldays.splice(index, 1);
      // // console.log(this.days);
    },
    updatebusiness() {
      document.getElementById('saveuserbtn').innerHTML = 'Loading...';
      let lat = '';
      let long = '';
      // Build formatted, filtered hours (strings) Sunday-first
      let business_hours = this.business_hours
        .filter((d) => !d.closed && d.from && d.from.hh && d.to && d.to.hh)
        .map((d) => ({
          day: d.day,
          from: `${d.from.hh}:${d.from.mm} ${d.from.A}`,
          to: `${d.to.hh}:${d.to.mm} ${d.to.A}`,
          closed: false,
        }));

      let leisure_hours = this.leisure_hours
        .filter((d) => !d.closed && d.from && d.from.hh && d.to && d.to.hh)
        .map((d) => ({
          day: d.day,
          from: `${d.from.hh}:${d.from.mm} ${d.from.A}`,
          to: `${d.to.hh}:${d.to.mm} ${d.to.A}`,
          closed: false,
        }));
      // for (var i = 0; i < this.leisure_hours.length; i++) {
      //     leisure_hours[i].from=this.leisure_hours[i].from.hh+':'+this.leisure_hours[i].from.mm+' '+this.leisure_hours[i].from.A;
      //     leisure_hours[i].to=this.leisure_hours[i].to.hh+':'+this.leisure_hours[i].to.mm+' '+this.leisure_hours[i].to.A;
      //     // console.log(leisure_hours[i]);
      //   }
      business_hours = JSON.stringify(business_hours);
      leisure_hours = JSON.stringify(leisure_hours);
      if (this.address) {
        lat = this.address.latitude;
        long = this.address.longitude;
        // console.log(lat);
        // console.log(long);
      } else if (this.model.gpslink) {
        let links = this.model.gpslink.split('@');
        if (links[1]) {
          let latlong = links[1].split(',');
          lat = latlong[0];
          long = latlong[1];
          // console.log(lat);
          // console.log(long);
        }
      }
      const querystring = require('querystring');
      const payload = {
        _id: this.model._id,
        user_email: this.model.user_email,
        user_password: this.model.user_password,
        user_type: 'Business',
        user_public_name: (this.model.user_public_name || '').trim(),
        user_country: this.model.user_country,
        business_name_english: this.model.business_name_english,
        business_description_english: this.model.business_description_english,
        business_email: this.model.business_email,
        business_name_arabic: this.model.business_name_arabic,
        business_description_arabic: this.model.business_description_arabic,
        business_type: this.model.business_type,
        business_category: this.model.business_categories, // <-- use the array
        business_subcategory: this.model.business_subcategories, // <-- use the array
        address: this.model.address,
        noofquotes: this.model.noofquotes,
        max_hashtags: this.model.max_hashtags,
        address_ar: this.model.address_ar,
        business_city: this.model.business_city,
        user_phone: this.model.user_phone,
        web_link: this.model.web_link,
        fb_link: this.model.fb_link,
        instagram_link: this.model.instagram_link,
        youtube_link: this.model.youtube_link,
        twitter_link: this.model.twitter_link,
        whatsapp_number: this.model.whatsapp_number,
        business_hours: business_hours,
        leisure_hours: leisure_hours,
        logo: this.model.logo,
        cover_image: this.model.cover_image,
        location_lat: lat,
        location_long: long,
      };
      console.log('Update payload:', payload);

      axios;
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'update_business_user_byId',
          querystring.stringify(payload),
          this.auth1
        )
        .then((response) => {
          if (response.data && response.data.success === false) {
            swal({
              title: 'Error',
              text: response.data.message || 'Update failed',
              icon: 'warning',
            });
            document.getElementById('saveuserbtn').innerHTML =
              'Update Business';
            return;
          }
          // Send claim email if checkbox is checked
          if (this.sendClaimEmail) {
            let username = this.model.user_public_name || '';
            let subject_body = 'Business Claim Email';
            axios
              .post(
                process.env.VUE_APP_API_ENDPOINT + 'send_business_claim_email',
                {
                  user_email: this.model.user_email,
                  business_name: this.model.business_name_english,
                  user_name: this.model.user_public_name, // optional but recommended
                  language: this.model.user_language, // optional, "en" or "ar"
                },
                this.auth
              )
              .then((response) => {
                // Optionally handle response
              });
          }

          if (this.selected) {
            let username = '';
            let subject_body = 'New business user link';
            let html_body = '';

            axios
              .post(
                process.env.VUE_APP_API_ENDPOINT + 'send_mail',
                {
                  email: this.model.user_email,
                  user_name: username,
                  subject_body: subject_body,
                  type: 'newbusinessuserprofile',
                  _id: response.data.user_details[0]._id,
                },
                this.auth
              )
              .then((response) => {
                // console.log(response.data);
              });
          }
          document
            .getElementById('saveuserbtn')
            .classList.remove('btn-primary');
          document.getElementById('saveuserbtn').classList.add('btn-success');
          document.getElementById('saveuserbtn').innerHTML = 'Updated';
          setTimeout(function() {
            document
              .getElementById('saveuserbtn')
              .classList.remove('btn-success');
            document.getElementById('saveuserbtn').classList.add('btn-primary');
            document.getElementById('saveuserbtn').innerHTML =
              'Update business';
          }, 2000);
        })
        .catch((error) => {
          console.error('Error updating business:', error);
          document.getElementById('saveuserbtn').innerHTML = 'Update business';
          document
            .getElementById('saveuserbtn')
            .classList.remove('btn-primary');
          document.getElementById('saveuserbtn').classList.add('btn-danger');
          setTimeout(function() {
            document
              .getElementById('saveuserbtn')
              .classList.remove('btn-danger');
            document.getElementById('saveuserbtn').classList.add('btn-primary');
            document.getElementById('saveuserbtn').innerHTML =
              'Update business';
          }, 2000);
        });
    },
    getsubcategories(event) {
      const querystring = require('querystring');
      //this.filtercategorybusiness();
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'read_business_subcategory',
          querystring.stringify({
            business_category_oid: this.model.business_category,
          }),
          this.auth1
        )
        .then((response) => {
          // console.log(response);
          if (response.data.details) {
            this.subcategories = response.data.details;
            //this.model.category_name=response.data.subcategory_data[0].category_name;
          }
        });
    },
    isValidEmail() {
      // Regular expression for a valid email pattern
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      // Use the test() method to check if the email matches the pattern
      emailPattern.test(this.model.user_email)
        ? (this.emailValid = true)
        : (this.emailValid = false);
    },
    isValidusername() {
      // Usernames are stored lowercase for uniformity.
      this.model.user_public_name = (
        this.model.user_public_name || ''
      ).toLowerCase();
      const name = (this.model.user_public_name || '').trim();
      if (name.length < 4) {
        this.usernamelength = true;
        this.username = false;
        this.specialcharacter = false;
      } else if (!/^[a-zA-Z0-9._]+$/.test(name)) {
        this.usernamelength = false;
        this.username = false;
        this.specialcharacter = true;
      } else if (name === this.originalUsername) {
        // Unchanged - no availability check needed (it would match itself)
        this.username = false;
        this.usernamelength = false;
        this.specialcharacter = false;
      } else {
        axios
          .post(
            process.env.VUE_APP_API_ENDPOINT + 'search_business_user_name',
            { user_name: name, exclude_id: this.model._id },
            this.auth
          )
          .then((response) => {
            if (response.data.details) {
              this.username = true;
              this.usernamelength = false;
              this.specialcharacter = false;
            } else {
              this.username = false;
              this.usernamelength = false;
              this.specialcharacter = false;
            }
          })
          .catch(() => {
            // Don't let a failed availability check permanently block the
            // save button - the server re-validates on submit anyway.
            this.username = false;
          });
      }
    },
    getbusinesssubcategories(event) {
      const querystring = require('querystring');
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'read_business_subcategory',
          querystring.stringify({
            business_category_oid: this.model.business_category,
          }),
          this.auth1
        )
        .then((response) => {
          // console.log(response);
          if (response.data.details) {
            this.subcategories = response.data.details;
            //this.model.category_name=response.data.subcategory_data[0].category_name;
          }
        });
    },
    filterbusiness() {
      // Method is commented out but keeping the structure
      // Implementation removed for now
    },
    convertTimeStringToObject(timeString) {
      // Convert time string like "8:00 AM", "09:00", or "18:00" to object {hh: "09", mm: "00", A: "AM"}
      console.log('Converting time string:', timeString, typeof timeString);

      if (!timeString || timeString.trim() === '') {
        console.log('Empty time string, returning default');
        return { hh: '', mm: '', A: 'AM' };
      }

      // If it's already an object, return it
      if (typeof timeString === 'object' && timeString !== null) {
        console.log('Already an object, returning as is:', timeString);
        return timeString;
      }

      try {
        const str = String(timeString).trim();

        // Match "hh:mm AM/PM" (12-hour format)
        const match12Hour = str.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
        if (match12Hour) {
          let hh = match12Hour[1].padStart(2, '0');
          let mm = match12Hour[2].padStart(2, '0');
          let A = match12Hour[3].toUpperCase();
          console.log('Parsed 12-hour time:', { hh, mm, A });
          return { hh, mm, A };
        }

        // Match "hh:mm" (24-hour format) - convert to 12-hour
        const match24Hour = str.match(/(\d{1,2}):(\d{2})/);
        if (match24Hour) {
          let hour24 = parseInt(match24Hour[1]);
          let mm = match24Hour[2].padStart(2, '0');
          let hh, A;

          if (hour24 === 0) {
            hh = '12';
            A = 'AM';
          } else if (hour24 < 12) {
            hh = hour24.toString().padStart(2, '0');
            A = 'AM';
          } else if (hour24 === 12) {
            hh = '12';
            A = 'PM';
          } else {
            hh = (hour24 - 12).toString().padStart(2, '0');
            A = 'PM';
          }

          console.log('Parsed 24-hour time:', { hh, mm, A });
          return { hh, mm, A };
        }

        // Fallback: just hour and minute
        const simpleParts = str.split(':');
        if (simpleParts.length >= 2) {
          let hh = simpleParts[0].trim().padStart(2, '0');
          let mm = simpleParts[1].replace(/[^0-9]/g, '').padStart(2, '0');
          console.log('Fallback parsed time:', { hh, mm, A: 'AM' });
          return { hh, mm, A: 'AM' };
        }
      } catch (e) {
        console.error('Error parsing time string:', timeString, e);
      }

      console.log('Failed to parse, returning default');
      return { hh: '', mm: '', A: 'AM' };
    },
    toggleBusinessDay(index) {
      if (this.business_hours[index].closed) {
        this.business_hours[index].from = { hh: '', mm: '', A: 'AM' };
        this.business_hours[index].to = { hh: '', mm: '', A: 'AM' };
      }
    },
    toggleLeisureDay(index) {
      if (this.leisure_hours[index].closed) {
        this.leisure_hours[index].from = { hh: '', mm: '', A: 'AM' };
        this.leisure_hours[index].to = { hh: '', mm: '', A: 'AM' };
      }
    },
  },
};
</script>
<style scoped>
/* Google-style hour row styling */
.google-hour-row {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.google-hour-row:hover {
  background: #e9ecef;
  border-color: #dee2e6;
}

.closed-day-row {
  background: #f8f9fa !important;
  opacity: 0.7;
}

.day-name {
  min-width: 120px;
}

.time-input-group {
  width: 120px;
}

.google-time-input {
  border: 1px solid #ced4da !important;
  border-radius: 6px !important;
  font-size: 14px !important;
  padding: 8px 12px !important;
  background: white !important;
  transition: all 0.2s ease !important;
}

.google-time-input:focus {
  border-color: #4285f4 !important;
  box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2) !important;
  outline: none !important;
}

.closed-text {
  font-size: 14px;
}

.custom-control-label {
  cursor: pointer;
}

.font-weight-600 {
  font-weight: 600;
}

.font-weight-800 {
  font-weight: 800;
}

.cursor-pointer {
  cursor: pointer;
}

.rounded-lg {
  border-radius: 8px;
}

/* Primary color for business hours */
.google-hour-row.business-hours {
  border-left: 4px solid #4285f4;
}

/* Secondary color for leisure hours */
.google-hour-row.leisure-hours {
  border-left: 4px solid #fbbc04;
}

.hours-container .hour-row:last-child .google-hour-row {
  margin-bottom: 0;
}

.fancy-claim-checkbox .custom-control-label {
  font-weight: 600;
  font-size: 1rem;
  color: #2563eb;
  cursor: pointer;
  transition: color 0.2s;
}
.fancy-claim-checkbox .custom-control-input:checked ~ .custom-control-label {
  color: #16a34a;
}
.fancy-claim-checkbox .spinner-border {
  vertical-align: middle;
}
</style>
